import 'core-js/modules/es.promise.js';
import { __awaiter } from '../../_virtual/_tslib.js';

const waitFor = (ms = 1000) => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise(resolve => setInterval(resolve, ms));
});

export { waitFor };
